export const reviewCompleteLabel = {
  HEADER_TEXT: "Review Complete",
  SUB_HEADER_TEXT:
    "Please enter any information that you wish to accompany the next stage of the claim, these notes will only be visible internally and not seen by any Trade Buyer.",
};
